// @flow

// import { colors } from 'material-ui'

export default (theme: any) => ({
  root: {
    '& > div': {
      height: '36px'
    },
    display: 'inline-block'
  }
})



// WEBPACK FOOTER //
// ./src/components/Icons/styles.js